import {I18nSupportedLocale} from './constants';
import {Locales} from './utils';

export const I18nSupportedLocaleLabel = Locales<
	Record<I18nSupportedLocale, string>
>((i18n) => ({
	[I18nSupportedLocale.ENGLISH]: i18n('i18n.languageEnglish'),
	[I18nSupportedLocale.FRENCH]: i18n('i18n.languageFrench'),
	[I18nSupportedLocale.GERMAN]: i18n('i18n.languageGerman'),
	[I18nSupportedLocale.JAPANESE]: i18n('i18n.languageJapanese'),
}));
